<template>
  <BaseLabel
    v-editable="blok"
    :background-color="blok.bg_color && blok.bg_color.color_name"
    :has-blue-background="isBlue"
    :has-navy-border="hasNavyBorder"
    :is-small="blok.is_small"
    :is-absolute="blok.is_absolute"
  >
    <template #default>
      <StoryblokComponent
        v-for="childBlok in blok.text"
        :key="childBlok._uid"
        class="label__text"
        :blok="childBlok"
      />
    </template>
  </BaseLabel>
</template>

<script lang="ts" setup>
import type { SbOverlayLabelStoryblok } from '@/types'
interface Props {
  blok: SbOverlayLabelStoryblok
}
const props = defineProps<Props>()

const isBlue = computed(() => {
  return props.blok.style === 'blue_bg'
})
const hasNavyBorder = computed(() => {
  return props.blok.style === 'navy_border'
})
</script>
